import { useState, useEffect } from "react";
import EmailCampaignsPro from "./EmailCampaignsPro";
import TrendStudio from "./TrendStudio";
import AdBrain from "./AdBrain";

const C = {
  bg:"#f8f5f0", surface:"#ffffff", card:"#ffffff", border:"#e8e4df",
  borderGold:"rgba(201,168,76,0.25)", goldBg:"rgba(201,168,76,0.08)",
  gold:"#c9a84c", goldL:"#e8c96a", goldD:"#8a6f2e",
  green:"#2ecc87", greenL:"rgba(46,204,135,0.12)",
  red:"#e05555", redL:"rgba(224,85,85,0.12)",
  blue:"#4a9eff", blueL:"rgba(74,158,255,0.12)",
  purple:"#9b6ef3", purpleL:"rgba(155,110,243,0.12)",
  teal:"#2dd4bf", tealL:"rgba(45,212,191,0.12)",
  orange:"#f97316", orangeL:"rgba(249,115,22,0.12)",
  pink:"#ec4899", pinkL:"rgba(236,72,153,0.12)",
  text:"#1a1a2e", muted:"#6b7280", dim:"#9ca3af", light:"#f3f4f6",
};
const F="'Montserrat','Plus Jakarta Sans',sans-serif";
const S="'Playfair Display','Cormorant Garamond',Georgia,serif";

// ── DATA ──────────────────────────────────────────────────────────────────────
const CAMPAIGNS=[
  {id:1,name:"Spring Botox — 15% Off",type:"email",status:"sent",sent:847,opens:512,clicks:189,conversions:38,revenue:30400,date:"Jan 20, 2024",segment:"All clients"},
  {id:2,name:"VIP Birthday Offer",type:"email",status:"sent",sent:12,opens:10,clicks:8,conversions:6,revenue:4800,date:"Jan 18, 2024",segment:"Birthday this month"},
  {id:3,name:"Filler Promo — Feb",type:"email",status:"scheduled",sent:0,opens:0,clicks:0,conversions:0,revenue:0,date:"Feb 1, 2024",segment:"Filler clients"},
  {id:4,name:"No-Show Recovery",type:"sms",status:"sent",sent:8,opens:8,clicks:5,conversions:3,revenue:1200,date:"Jan 15, 2024",segment:"No-show clients"},
  {id:5,name:"Membership Renewal",type:"sms",status:"active",sent:24,opens:24,clicks:18,conversions:14,revenue:5600,date:"Jan 22, 2024",segment:"Expiring members"},
];

const FLOWS=[
  {id:1,name:"Post-Treatment Follow-up",trigger:"24h after appointment",channel:"SMS",sent:147,opens:"94%",conv:"28%",active:true,color:C.gold},
  {id:2,name:"Birthday Offer",trigger:"7 days before birthday",channel:"Email",sent:42,opens:"81%",conv:"35%",active:true,color:C.purple},
  {id:3,name:"Win-Back Campaign",trigger:"90 days no visit",channel:"Email+SMS",sent:28,opens:"52%",conv:"18%",active:true,color:C.teal},
  {id:4,name:"Botox Reminder",trigger:"3 months after Botox",channel:"SMS",sent:89,opens:"88%",conv:"42%",active:true,color:C.blue},
  {id:5,name:"No-Show Recovery",trigger:"1h after missed appt",channel:"SMS",sent:15,opens:"100%",conv:"40%",active:false,color:C.red},
  {id:6,name:"GFE Expiry Alert",trigger:"30 days before expiry",channel:"Email",sent:8,opens:"75%",conv:"62%",active:true,color:C.orange},
];


const LEADS=[
  {id:1,name:"Stephanie Moore",phone:"(310) 555-0421",email:"stephanie@email.com",source:"Meta Ad",interest:"Botox",status:"qualified",score:85,value:800,date:"Jan 22",assigned:"Dr. Ashley Monroe",notes:"Saw Spring Glow ad. Ready to book."},
  {id:2,name:"Brandon Lee",phone:"(424) 555-0532",email:"brandon@email.com",source:"Instagram",interest:"GLP-1",status:"contacted",score:72,value:600,date:"Jan 21",assigned:"Dr. Ashley Monroe",notes:"DM from Reel. Interested in weight loss."},
  {id:3,name:"Priya Patel",phone:"(213) 555-0643",email:"priya@email.com",source:"Google",interest:"RF Microneedling",status:"new",score:60,value:750,date:"Jan 20",assigned:"Madison Park RN",notes:"Google search lead."},
  {id:4,name:"Marcus Williams",phone:"(818) 555-0754",email:"marcus@email.com",source:"Referral",interest:"Botox + Filler",status:"proposal",score:91,value:1700,date:"Jan 19",assigned:"Chloe Kim NP",notes:"Referred by Dana Whitfield. High intent."},
  {id:5,name:"Emily Chen",phone:"(323) 555-0865",email:"emily@email.com",source:"Meta Ad",interest:"Lip Filler",status:"closed",score:95,value:900,date:"Jan 15",assigned:"Chloe Kim NP",notes:"Booked via Lip Filler ad. Appointment Jan 25."},
];

const REVIEWS=[
  {id:1,platform:"Google",author:"Sarah M.",rating:5,text:"Absolutely love this place! Dr. Monroe is incredible — natural results every time. The facility is stunning and staff so welcoming.",date:"Jan 20, 2024",replied:true},
  {id:2,platform:"Google",author:"Jennifer T.",rating:5,text:"Best med spa in Beverly Hills hands down. The GLP-1 program changed my life. Down 18 lbs in 3 months!",date:"Jan 18, 2024",replied:false},
  {id:3,platform:"Yelp",author:"David K.",rating:4,text:"Great experience overall. Chloe was amazing with my lip filler. Took off one star for parking situation.",date:"Jan 15, 2024",replied:true},
  {id:4,platform:"RealSelf",author:"Anonymous",rating:5,text:"Had Ultherapy done here and the results are beyond what I expected. Worth every penny.",date:"Jan 10, 2024",replied:false},
  {id:5,platform:"Google",author:"Michelle R.",rating:2,text:"Had to wait 20 minutes past my appointment time. Results were fine but the wait was frustrating.",date:"Jan 8, 2024",replied:false},
];

const TRENDING=[
  {topic:"GLP-1 Ozempic Face",hook:"'Ozempic face' is real — here's how we reverse it with fillers 💉",platform:"TikTok+Reels",trend:"🔥 Very Hot",searches:"+840%"},
  {topic:"Preventative Botox 20s",hook:"Starting Botox in your 20s is the new skincare routine — here's why",platform:"Instagram",trend:"📈 Rising",searches:"+320%"},
  {topic:"Pillow Face Prevention",hook:"What nobody tells you about filler — and how to avoid the 'pillow face' look",platform:"TikTok",trend:"🔥 Hot",searches:"+180%"},
  {topic:"Natural Lip Filler",hook:"Natural lip filler that ACTUALLY looks real — before & after transformation",platform:"Instagram+TikTok",trend:"💚 Evergreen",searches:"+95%"},
  {topic:"Male Aesthetics",hook:"Men are getting Botox too — and the results are incredible",platform:"Instagram",trend:"📈 Rising",searches:"+210%"},
  {topic:"Skin Cycling",hook:"Skin cycling but for your in-office treatments — the protocol our providers swear by",platform:"Instagram",trend:"💚 Evergreen",searches:"+140%"},
];

const CONTENT_CAL=[
  {date:"Jan 22",type:"Reel",topic:"Botox myth busting",status:"published",platform:"Instagram+TikTok"},
  {date:"Jan 24",type:"Post",topic:"Before/After Cheek Filler",status:"published",platform:"Instagram"},
  {date:"Jan 26",type:"Story",topic:"Meet Dr. Monroe",status:"scheduled",platform:"Instagram"},
  {date:"Jan 28",type:"Reel",topic:"GLP-1 transformation",status:"draft",platform:"TikTok"},
  {date:"Jan 30",type:"Post",topic:"Valentine's Day offer",status:"draft",platform:"All"},
  {date:"Feb 1",type:"Reel",topic:"Lip filler natural look",status:"idea",platform:"Instagram"},
  {date:"Feb 3",type:"Email",topic:"February newsletter",status:"idea",platform:"Email"},
];

// ── SHARED ────────────────────────────────────────────────────────────────────
const inp={width:"100%",padding:"10px 14px",background:"#f3f4f6",border:"1px solid #e8e4df",borderRadius:8,fontSize:13,color:"#1a1a2e",fontFamily:F,outline:"none",boxSizing:"border-box"};
const Fld=({label,children,col})=>(<div style={{gridColumn:col}}><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>{label}</label>{children}</div>);

function Btn({children,v="primary",onClick,sz="md",full,style:ex}){
  const sizes={sm:{padding:"5px 12px",fontSize:11},md:{padding:"9px 18px",fontSize:13},lg:{padding:"12px 28px",fontSize:14}};
  const vars={
    primary:{background:`linear-gradient(135deg,${C.gold},${C.goldD})`,color:"#ffffff"},
    ghost:{background:"transparent",color:C.muted,border:`1px solid ${C.border}`},
    danger:{background:C.redL,color:C.red,border:"1px solid rgba(224,85,85,0.25)"},
    success:{background:C.greenL,color:C.green,border:"1px solid rgba(46,204,135,0.25)"},
    sec:{background:C.goldBg,color:C.gold,border:`1px solid ${C.borderGold}`},
    blue:{background:C.blueL,color:C.blue,border:`1px solid rgba(74,158,255,0.25)`},
    purple:{background:C.purpleL,color:C.purple,border:`1px solid rgba(155,110,243,0.25)`},
    pink:{background:C.pinkL,color:C.pink,border:`1px solid rgba(236,72,153,0.25)`},
  };
  return <button onClick={onClick} style={{display:"inline-flex",alignItems:"center",gap:6,borderRadius:8,fontWeight:600,cursor:"pointer",fontFamily:F,border:"none",transition:"all 0.15s",whiteSpace:"nowrap",justifyContent:"center",...sizes[sz],...(vars[v]||vars.ghost),...(full?{width:"100%"}:{}),...ex}}>{children}</button>;
}

function Card({children,style,onClick}){return <div onClick={onClick} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,overflow:"hidden",...style}}>{children}</div>;}

function Modal({title,onClose,children,w=640}){
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20,backdropFilter:"blur(8px)"}}>
      <div style={{background:C.card,border:`1px solid ${C.borderGold}`,borderRadius:16,width:"100%",maxWidth:w,maxHeight:"90vh",overflow:"auto",boxShadow:"0 32px 80px rgba(0,0,0,0.6)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"20px 24px",borderBottom:`1px solid ${C.border}`}}>
          <h3 style={{margin:0,fontSize:16,fontWeight:700,color:C.gold,fontFamily:S}}>{title}</h3>
          <button onClick={onClose} style={{background:C.light,border:"none",borderRadius:8,padding:6,cursor:"pointer",color:C.muted,display:"flex"}}><span style={{fontSize:14}}>✕</span></button>
        </div>
        <div style={{padding:24}}>{children}</div>
      </div>
    </div>
  );
}

function StatCard({label,value,sub,color,trend}){
  return(
    <Card style={{padding:"18px 20px"}}>
      <div style={{fontSize:24,fontWeight:800,color,fontFamily:S,marginBottom:4}}>{value}</div>
      <div style={{fontSize:12,color:C.muted}}>{label}</div>
      {sub&&<div style={{fontSize:11,color:C.dim,marginTop:2}}>{sub}</div>}
      {trend!==undefined&&<div style={{fontSize:11,fontWeight:700,color:trend>0?C.green:C.red,marginTop:4}}>{trend>0?"+":""}{trend}%</div>}
    </Card>
  );
}

// ── AI GENERATOR ──────────────────────────────────────────────────────────────
function AIGenerator({type,onInsert}){
  const [generating,setGenerating]=useState(false);
  const [result,setResult]=useState("");
  const [topic,setTopic]=useState("");

  const TEMPLATES={
    email:{
      "Botox Spring Promo":"Subject: Spring into a Fresher You — 15% Off Botox This Month ✨\n\nDear [Name],\n\nSpring is just around the corner, and there's no better time to refresh your look. This month only, we're offering 15% off all Botox treatments at Elyon.\n\n✨ What's included:\n• Forehead lines\n• Crow's feet\n• Brow lift\n• Lip flip\n\nSpots are extremely limited. Our providers book up weeks in advance.\n\n→ Book Your Appointment\n\nWith warmth,\nElyon Med Spa Team",
      "VIP Birthday":"Subject: Happy Birthday, [Name] 🎂 — A Special Gift Inside\n\nDear [Name],\n\nBirthday wishes from your Elyon family! As our treasured VIP client, we'd love to celebrate you this month with something special.\n\n🎁 Your Birthday Gift:\n• FREE 15-minute consultation ($150 value)\n• 20% off any treatment booked this month\n• Complimentary glass of champagne during your visit\n\nThis offer expires at the end of your birthday month.\n\n→ Claim Your Birthday Gift\n\nCheers to you,\nThe Elyon Team",
      "Win-Back":"Subject: We miss you, [Name] — It's Been a While\n\nDear [Name],\n\nWe noticed it's been a few months since your last visit, and we genuinely miss seeing you. Life gets busy — we get it.\n\nWe'd love to welcome you back with a special offer just for you:\n\n💌 15% off your next treatment\n💌 Priority booking — skip the waitlist\n💌 Complimentary skin analysis\n\nOffer valid for the next 14 days only.\n\n→ Book Your Return Visit\n\nWarm regards,\nElyon Med Spa",
    },
    sms:{
      "Botox Reminder":"Hey [Name]! Your Botox from 3 months ago is due for a refresh 💉 Spots are limited this week — book now: book.elyon.io/beverly-hills Reply STOP to opt out.",
      "No-Show Recovery":"Hi [Name], we missed you today! Life happens 😊 We'd love to reschedule — reply YES and we'll find you the next available slot. Or book anytime: book.elyon.io",
      "Flash Sale":"⚡ ELYON EXCLUSIVE: 20% off HydraFacial this week only! Only 5 spots left. Book now: book.elyon.io/beverly-hills — Expires Friday. Reply STOP to opt out.",
    },
  };

  const generate=()=>{
    if(!topic)return;
    setGenerating(true);
    setTimeout(()=>{
      const templates=TEMPLATES[type]||{};
      const keys=Object.keys(templates);
      const match=keys.find(k=>topic.toLowerCase().includes(k.toLowerCase().split(" ")[0]));
      const content=match?templates[match]:Object.values(templates)[0];
      setResult(content);
      setGenerating(false);
    },1800);
  };

  return(
    <div style={{padding:18,background:C.goldBg,borderRadius:12,border:`1px solid ${C.borderGold}`}}>
      <div style={{fontSize:13,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:10}}>🤖 AI Campaign Generator</div>
      <div style={{display:"flex",gap:8,marginBottom:10}}>
        <select value={topic} onChange={e=>setTopic(e.target.value)} style={{...inp,flex:1}}>
          <option value="">Select campaign type...</option>
          {Object.keys(TEMPLATES[type]||{}).map(k=><option key={k} value={k}>{k}</option>)}
          <option value="custom">Custom topic...</option>
        </select>
        <Btn onClick={generate} disabled={!topic}>{generating?"Generating...":"✨ Generate"}</Btn>
      </div>
      {generating&&(
        <div style={{textAlign:"center",padding:"20px",color:C.muted,fontSize:12}}>
          <div style={{marginBottom:8}}>🤖 AI is crafting your campaign...</div>
          <div style={{display:"flex",gap:6,justifyContent:"center"}}>
            {["Analyzing client data","Optimizing subject line","Personalizing content","Adding CTAs"].map((t,i)=>(
              <span key={t} style={{fontSize:10,padding:"3px 8px",background:C.surface,borderRadius:8,color:C.dim}}>{t}</span>
            ))}
          </div>
        </div>
      )}
      {result&&!generating&&(
        <div>
          <div style={{background:C.surface,borderRadius:8,padding:14,border:`1px solid ${C.border}`,marginBottom:10}}>
            <pre style={{margin:0,fontSize:12,color:C.text,fontFamily:F,lineHeight:1.7,whiteSpace:"pre-wrap"}}>{result}</pre>
          </div>
          <div style={{display:"flex",gap:8}}>
            <Btn sz="sm" v="success" onClick={()=>onInsert&&onInsert(result)}>✓ Use This</Btn>
            <Btn sz="sm" v="ghost" onClick={generate}>↺ Regenerate</Btn>
            <Btn sz="sm" v="ghost" onClick={()=>setResult("")}>Clear</Btn>
          </div>
        </div>
      )}
    </div>
  );
}

// ── EMAIL CAMPAIGNS ───────────────────────────────────────────────────────────
function EmailCampaigns(){
  const [view,setView]=useState("list");
  const [form,setForm]=useState({name:"",subject:"",body:"",segment:"All clients",schedule:"now",scheduleDate:"",image:null});
  const [campaigns,setCampaigns]=useState(CAMPAIGNS.filter(c=>c.type==="email"));
  const [showF,setShowF]=useState(false);
  const [sending,setSending]=useState(false);
  const [sent,setSent]=useState(false);

  const totalSent=campaigns.reduce((s,c)=>s+c.sent,0);
  const avgOpen=Math.round(campaigns.filter(c=>c.sent>0).reduce((s,c)=>s+(c.opens/c.sent*100),0)/campaigns.filter(c=>c.sent>0).length);
  const totalRevenue=campaigns.reduce((s,c)=>s+c.revenue,0);

  const sendCampaign=()=>{
    setSending(true);
    setTimeout(()=>{setSending(false);setSent(true);},2500);
  };

  return(
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14}}>
        <StatCard label="Total Sent" value={totalSent.toLocaleString()} color={C.gold} trend={12}/>
        <StatCard label="Avg Open Rate" value={`${avgOpen}%`} color={C.green} sub="Industry avg: 21%"/>
        <StatCard label="Revenue Generated" value={`$${totalRevenue.toLocaleString()}`} color={C.purple} trend={28}/>
        <StatCard label="Active Campaigns" value={campaigns.filter(c=>c.status==="scheduled").length} color={C.teal}/>
      </div>

      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{display:"flex",gap:4,background:C.surface,padding:4,borderRadius:10,border:`1px solid ${C.border}`}}>
          {[["list","Campaigns"],["flows","Automation"]].map(([v,l])=>(
            <button key={v} onClick={()=>setView(v)} style={{padding:"6px 14px",fontSize:12,fontWeight:view===v?700:500,color:view===v?"#09090b":C.muted,background:view===v?C.gold:"none",borderRadius:7,border:"none",cursor:"pointer",fontFamily:F}}>{l}</button>
          ))}
        </div>
        <Btn onClick={()=>{setShowF(true);setSent(false);}}>✉️ New Email Campaign</Btn>
      </div>

      {view==="list"&&(
        <Card>
          <div style={{padding:"14px 20px",borderBottom:`1px solid ${C.border}`}}>
            <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S}}>Email Campaigns</div>
          </div>
          {campaigns.map(c=>(
            <div key={c.id} style={{padding:"16px 20px",borderBottom:`1px solid ${C.border}`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                <div>
                  <div style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:3}}>{c.name}</div>
                  <div style={{fontSize:12,color:C.muted}}>Segment: {c.segment} · {c.date}</div>
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <span style={{fontSize:11,padding:"3px 10px",borderRadius:20,background:c.status==="sent"?C.greenL:c.status==="scheduled"?C.goldBg:C.blueL,color:c.status==="sent"?C.green:c.status==="scheduled"?C.gold:C.blue,fontWeight:600}}>{c.status}</span>
                  <Btn sz="sm" v="ghost">View</Btn>
                  {c.status==="scheduled"&&<Btn sz="sm" v="sec">Edit</Btn>}
                </div>
              </div>
              {c.sent>0&&(
                <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:10}}>
                  {[["Sent",c.sent.toLocaleString(),C.muted],["Opens",`${Math.round(c.opens/c.sent*100)}%`,C.teal],["Clicks",`${Math.round(c.clicks/c.sent*100)}%`,C.blue],["Conversions",c.conversions,C.green],["Revenue",`$${c.revenue.toLocaleString()}`,C.gold]].map(([l,v,col])=>(
                    <div key={l} style={{padding:"8px 10px",background:C.surface,borderRadius:8,textAlign:"center",border:`1px solid ${C.border}`}}>
                      <div style={{fontSize:13,fontWeight:700,color:col}}>{v}</div>
                      <div style={{fontSize:10,color:C.dim}}>{l}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </Card>
      )}

      {view==="flows"&&(
        <Card>
          <div style={{padding:"14px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between"}}>
            <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S}}>Automation Flows</div>
            <Btn sz="sm" v="sec">+ New Flow</Btn>
          </div>
          {FLOWS.map(f=>(
            <div key={f.id} style={{padding:"14px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",gap:14}}>
              <div style={{width:10,height:10,borderRadius:"50%",background:f.active?C.green:C.light,boxShadow:f.active?`0 0 8px ${C.green}`:"none",flexShrink:0}}/>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:600,color:C.text,marginBottom:2}}>{f.name}</div>
                <div style={{fontSize:11,color:C.muted}}>{f.trigger} · {f.channel}</div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,50px)",gap:8,textAlign:"center"}}>
                {[["Sent",f.sent,C.muted],["Opens",f.opens,C.teal],["Conv",f.conv,C.green]].map(([l,v,c])=>(
                  <div key={l}><div style={{fontSize:12,fontWeight:700,color:c}}>{v}</div><div style={{fontSize:9,color:C.dim}}>{l}</div></div>
                ))}
              </div>
              <div onClick={()=>{}} style={{width:38,height:20,borderRadius:10,background:f.active?C.green:C.light,position:"relative",cursor:"pointer"}}>
                <div style={{position:"absolute",top:2,left:f.active?20:2,width:16,height:16,borderRadius:"50%",background:"#fff",transition:"left 0.2s"}}/>
              </div>
            </div>
          ))}
        </Card>
      )}

      {showF&&(
        <Modal title="New Email Campaign" onClose={()=>setShowF(false)} w={700}>
          {!sent?(
            <div style={{display:"flex",flexDirection:"column",gap:16}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
                <Fld label="Campaign Name" col="1/-1"><input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Spring Botox Promo" style={inp}/></Fld>
                <Fld label="Target Segment"><select value={form.segment} onChange={e=>setForm({...form,segment:e.target.value})} style={{...inp}}>
                  {["All clients","VIP only","Members only","No-show recovery","Birthday this month","Botox clients","Last visit 90+ days"].map(s=><option key={s}>{s}</option>)}
                </select></Fld>
                <Fld label="Schedule"><select value={form.schedule} onChange={e=>setForm({...form,schedule:e.target.value})} style={{...inp}}>
                  <option value="now">Send Now</option>
                  <option value="scheduled">Schedule for Later</option>
                </select></Fld>
                {form.schedule==="scheduled"&&<Fld label="Send Date & Time" col="1/-1"><input type="datetime-local" value={form.scheduleDate} onChange={e=>setForm({...form,scheduleDate:e.target.value})} style={inp}/></Fld>}
                <Fld label="Subject Line" col="1/-1"><input value={form.subject} onChange={e=>setForm({...form,subject:e.target.value})} placeholder="Spring into a fresher you..." style={inp}/></Fld>
              </div>

              <AIGenerator type="email" onInsert={(text)=>{const lines=text.split("\n");const subj=lines[0]?.replace("Subject: ","");const body=lines.slice(2).join("\n");setForm({...form,subject:subj,body:body});}}/>

              <Fld label="Email Body">
                <textarea value={form.body} onChange={e=>setForm({...form,body:e.target.value})} rows={8} style={{...inp,resize:"vertical"}} placeholder="Write your email content here or use AI Generator above..."/>
              </Fld>

              <Fld label="Add Image">
                <div style={{padding:"20px",background:C.surface,borderRadius:8,border:`2px dashed ${C.border}`,textAlign:"center",cursor:"pointer"}}>
                  <div style={{fontSize:24,marginBottom:8}}>📸</div>
                  <div style={{fontSize:12,color:C.muted}}>Drop image here or click to upload</div>
                  <div style={{fontSize:11,color:C.dim,marginTop:4}}>Or use AI to generate campaign image</div>
                  <div style={{display:"flex",gap:8,justifyContent:"center",marginTop:12}}>
                    <Btn sz="sm" v="ghost">Upload Image</Btn>
                    <Btn sz="sm" v="sec">🎨 AI Generate Image</Btn>
                  </div>
                </div>
              </Fld>

              <div style={{padding:"12px 14px",background:C.goldBg,borderRadius:8,border:`1px solid ${C.borderGold}`,fontSize:12,color:C.muted}}>
                📊 Estimated reach: <strong style={{color:C.gold}}>847 clients</strong> · Estimated open rate: <strong style={{color:C.gold}}>54%</strong>
              </div>

              <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
                <Btn v="ghost" onClick={()=>setShowF(false)}>Cancel</Btn>
                <Btn v="ghost">Save as Draft</Btn>
                <Btn onClick={sendCampaign} disabled={sending}>{sending?"Sending...⏳":"🚀 Send Campaign"}</Btn>
              </div>
            </div>
          ):(
            <div style={{textAlign:"center",padding:32}}>
              <div style={{fontSize:48,marginBottom:16}}>🚀</div>
              <div style={{fontSize:20,fontWeight:800,color:C.gold,fontFamily:S,marginBottom:8}}>Campaign Sent!</div>
              <div style={{fontSize:13,color:C.muted,marginBottom:20}}>Your campaign is on its way to {form.segment === "All clients" ? "847" : "~50"} clients.</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20}}>
                {[["Recipients","847",C.gold],["Est. Opens","457 (54%)",C.green],["Est. Revenue","$12,000+",C.purple]].map(([l,v,c])=>(
                  <div key={l} style={{padding:"12px",background:C.surface,borderRadius:10,border:`1px solid ${C.border}`}}>
                    <div style={{fontSize:16,fontWeight:800,color:c,fontFamily:S}}>{v}</div>
                    <div style={{fontSize:11,color:C.muted}}>{l}</div>
                  </div>
                ))}
              </div>
              <Btn onClick={()=>setShowF(false)}>Close</Btn>
            </div>
          )}
        </Modal>
      )}
    </div>
  );
}

// ── SMS CAMPAIGNS ─────────────────────────────────────────────────────────────
function SMSCampaigns(){
  const [showF,setShowF]=useState(false);
  const [form,setForm]=useState({message:"",segment:"All clients",schedule:"now"});
  const [charCount,setCharCount]=useState(0);
  const smsCampaigns=CAMPAIGNS.filter(c=>c.type==="sms");

  return(
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14}}>
        <StatCard label="SMS Sent" value={smsCampaigns.reduce((s,c)=>s+c.sent,0)} color={C.green} trend={8}/>
        <StatCard label="Delivery Rate" value="98.2%" color={C.teal} sub="Industry avg: 95%"/>
        <StatCard label="Avg Response Rate" value="32%" color={C.gold} sub="vs 6% email"/>
        <StatCard label="Revenue from SMS" value={`$${smsCampaigns.reduce((s,c)=>s+c.revenue,0).toLocaleString()}`} color={C.purple}/>
      </div>

      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S}}>SMS Campaigns</div>
        <Btn onClick={()=>setShowF(true)}>💬 New SMS Campaign</Btn>
      </div>

      <Card>
        {smsCampaigns.map(c=>(
          <div key={c.id} style={{padding:"16px 20px",borderBottom:`1px solid ${C.border}`}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:c.sent>0?10:0}}>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:C.text}}>{c.name}</div>
                <div style={{fontSize:11,color:C.muted}}>{c.segment} · {c.date}</div>
              </div>
              <span style={{fontSize:11,padding:"3px 10px",borderRadius:20,background:c.status==="sent"?C.greenL:C.goldBg,color:c.status==="sent"?C.green:C.gold,fontWeight:600}}>{c.status}</span>
            </div>
            {c.sent>0&&(
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10}}>
                {[["Sent",c.sent,C.muted],["Delivered",`${Math.round(c.opens/c.sent*100)}%`,C.green],["Conversions",c.conversions,C.gold],["Revenue",`$${c.revenue}`,C.purple]].map(([l,v,col])=>(
                  <div key={l} style={{padding:"8px",background:C.surface,borderRadius:8,textAlign:"center"}}>
                    <div style={{fontSize:13,fontWeight:700,color:col}}>{v}</div>
                    <div style={{fontSize:10,color:C.dim}}>{l}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </Card>

      {showF&&(
        <Modal title="New SMS Campaign" onClose={()=>setShowF(false)}>
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            <Fld label="Target Segment"><select style={{...inp}}>{["All clients","VIP only","Members only","No-show recovery","Botox clients","90+ days inactive"].map(s=><option key={s}>{s}</option>)}</select></Fld>

            <AIGenerator type="sms" onInsert={(t)=>{setForm({...form,message:t});setCharCount(t.length);}}/>

            <Fld label="Message">
              <div style={{position:"relative"}}>
                <textarea value={form.message} onChange={e=>{setForm({...form,message:e.target.value});setCharCount(e.target.value.length);}} rows={4} style={{...inp,resize:"none"}} placeholder="Type your SMS message..."/>
                <div style={{position:"absolute",bottom:8,right:10,fontSize:10,color:charCount>160?C.red:C.dim}}>{charCount}/160 chars {charCount>160?`(${Math.ceil(charCount/160)} SMS)`:"(1 SMS)"}</div>
              </div>
            </Fld>

            <div style={{padding:"12px",background:C.surface,borderRadius:8,border:`1px solid ${C.border}`}}>
              <div style={{fontSize:11,fontWeight:700,color:C.muted,marginBottom:6}}>PREVIEW — How it looks on phone</div>
              <div style={{background:"#1c1c1e",borderRadius:16,padding:"12px 16px",maxWidth:280,marginLeft:"auto",marginRight:"auto"}}>
                <div style={{fontSize:11,color:"rgba(255,255,255,0.4)",marginBottom:6,textAlign:"center"}}>ELYON MED SPA</div>
                <div style={{background:"#3a82f7",borderRadius:"18px 18px 4px 18px",padding:"10px 14px",fontSize:13,color:"#fff",lineHeight:1.5}}>{form.message||"Your message preview will appear here..."}</div>
              </div>
            </div>

            <div style={{display:"flex",gap:4}}>
              <Fld label="Schedule"><select style={{...inp}}><option>Send Now</option><option>Schedule Later</option></select></Fld>
            </div>

            <div style={{padding:"10px 14px",background:C.goldBg,borderRadius:8,border:`1px solid ${C.borderGold}`,fontSize:12,color:C.muted}}>
              ⚠️ SMS sent with opt-out instructions. Compliant with TCPA regulations. Reply STOP to opt out.
            </div>

            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <Btn v="ghost" onClick={()=>setShowF(false)}>Cancel</Btn>
              <Btn>📱 Send SMS Campaign</Btn>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── SOCIAL STUDIO ─────────────────────────────────────────────────────────────
function SocialStudio(){
  const [tab,setTab]=useState("trends");
  const [selTrend,setSelTrend]=useState(null);
  const [scriptGen,setScriptGen]=useState(false);
  const [script,setScript]=useState("");
  const [calFilter,setCalFilter]=useState("All");

  const STATUS_COLORS={published:C.green,scheduled:C.gold,draft:C.blue,idea:C.muted};

  const generateScript=(trend)=>{
    setScriptGen(true);
    setTimeout(()=>{
      setScript(`🎬 REEL SCRIPT — "${trend.topic}"\n\n📱 HOOK (0-3 sec):\n"${trend.hook}"\n\n🎯 INTRO (3-8 sec):\n"At Elyon in Beverly Hills, we see this every day. Here's what actually works..."\n\n💉 MAIN CONTENT (8-25 sec):\n• Show the treatment process\n• Explain the science briefly\n• Before/after transformation\n• Provider expertise moment\n\n🌟 SOCIAL PROOF (25-35 sec):\n"Our clients see results in as little as 2 weeks..."\n\n📞 CTA (35-45 sec):\n"Link in bio to book your consultation — first time clients get 15% off 💛"\n\n#MedSpa #BeverlyHills #${trend.topic.replace(/\s/g,"")} #Aesthetics #EliteAesthetics\n\n⏱ Total: ~45 seconds\n📐 Format: 9:16 vertical\n🎵 Trending audio recommended`);
      setScriptGen(false);
    },1500);
  };

  return(
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      <div style={{display:"flex",gap:4,background:C.surface,padding:4,borderRadius:10,border:`1px solid ${C.border}`,width:"fit-content"}}>
        {[["trends","🔥 Trending"],["content","✍️ Content Generator"],["calendar","📅 Content Calendar"]].map(([v,l])=>(
          <button key={v} onClick={()=>setTab(v)} style={{padding:"7px 14px",fontSize:12,fontWeight:tab===v?700:500,color:tab===v?"#09090b":C.muted,background:tab===v?C.gold:"none",borderRadius:7,border:"none",cursor:"pointer",fontFamily:F}}>{l}</button>
        ))}
      </div>

      {tab==="trends"&&(
        <div style={{display:"grid",gridTemplateColumns:selTrend?"1fr 400px":"1fr",gap:20}}>
          <div>
            <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:4}}>🔥 Trending in Med Spa Right Now</div>
            <div style={{fontSize:12,color:C.muted,marginBottom:16}}>AI-curated from TikTok, Instagram, Google Trends — updated daily</div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {TRENDING.map((t,i)=>(
                <Card key={i} onClick={()=>setSelTrend(t)} style={{padding:"16px 20px",cursor:"pointer",border:`1.5px solid ${selTrend===t?C.borderGold:C.border}`,background:selTrend===t?C.goldBg:C.card,transition:"all 0.2s"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                    <div style={{flex:1}}>
                      <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:6}}>
                        <span style={{fontSize:13,fontWeight:600,color:C.text}}>{t.topic}</span>
                        <span style={{fontSize:11,padding:"2px 8px",borderRadius:10,background:t.trend.includes("🔥")?C.redL:t.trend.includes("📈")?C.greenL:C.blueL,color:t.trend.includes("🔥")?C.red:t.trend.includes("📈")?C.green:C.blue,fontWeight:600}}>{t.trend}</span>
                      </div>
                      <div style={{fontSize:12,color:C.muted,fontStyle:"italic",marginBottom:6}}>"{t.hook}"</div>
                      <div style={{display:"flex",gap:8}}>
                        <span style={{fontSize:11,color:C.purple,background:C.purpleL,padding:"2px 8px",borderRadius:8}}>{t.platform}</span>
                        <span style={{fontSize:11,color:C.green,background:C.greenL,padding:"2px 8px",borderRadius:8}}>Searches {t.searches}</span>
                      </div>
                    </div>
                    <Btn sz="sm" v="sec" onClick={e=>{e.stopPropagation();setSelTrend(t);generateScript(t);}}>Generate Script</Btn>
                  </div>
                </Card>
              ))}
            </div>
          </div>

          {selTrend&&(
            <Card style={{position:"sticky",top:0}}>
              <div style={{padding:"16px 20px",borderBottom:`1px solid ${C.border}`,background:C.goldBg}}>
                <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S}}>✍️ Script Generator</div>
                <div style={{fontSize:11,color:C.muted,marginTop:2}}>{selTrend.topic}</div>
              </div>
              <div style={{padding:18,flex:1,overflow:"auto",maxHeight:"70vh"}}>
                {scriptGen&&(
                  <div style={{textAlign:"center",padding:"30px",color:C.muted,fontSize:12}}>
                    <div style={{fontSize:24,marginBottom:10}}>🎬</div>AI is writing your script...
                  </div>
                )}
                {script&&!scriptGen&&(
                  <div>
                    <pre style={{margin:0,fontSize:11,color:C.text,fontFamily:F,lineHeight:1.7,whiteSpace:"pre-wrap",marginBottom:14}}>{script}</pre>
                    <div style={{display:"flex",flexDirection:"column",gap:8}}>
                      <Btn full v="sec">📋 Copy Script</Btn>
                      <Btn full v="ghost" onClick={()=>generateScript(selTrend)}>↺ Regenerate</Btn>
                      <Btn full>📅 Add to Calendar</Btn>
                    </div>
                  </div>
                )}
                {!script&&!scriptGen&&(
                  <div style={{textAlign:"center",padding:"30px"}}>
                    <Btn full onClick={()=>generateScript(selTrend)}>🎬 Generate Script</Btn>
                  </div>
                )}
              </div>
            </Card>
          )}
        </div>
      )}

      {tab==="content"&&(
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
          <div style={{display:"flex",flexDirection:"column",gap:16}}>
            <Card style={{padding:22}}>
              <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:14}}>📝 Caption Generator</div>
              <Fld label="Treatment"><select style={{...inp,marginBottom:10}}>{["Botox","Lip Filler","HydraFacial","RF Microneedling","GLP-1","Before/After"].map(t=><option key={t}>{t}</option>)}</select></Fld>
              <Fld label="Tone"><select style={{...inp,marginBottom:14}}>{"Educational,Inspiring,Playful,Luxurious,Clinical".split(",").map(t=><option key={t}>{t}</option>)}</select></Fld>
              <Btn full>✨ Generate Caption + Hashtags</Btn>
            </Card>
            <Card style={{padding:22}}>
              <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:14}}>📊 Platform Best Times</div>
              {[["Instagram","Tue/Wed/Fri","11am, 1pm, 5pm"],["TikTok","Every day","7am, 12pm, 9pm"],["Facebook","Wed/Thu","1pm, 3pm"]].map(([p,days,times])=>(
                <div key={p} style={{padding:"10px 0",borderBottom:`1px solid ${C.border}`}}>
                  <div style={{fontSize:12,fontWeight:700,color:C.text,marginBottom:2}}>{p}</div>
                  <div style={{fontSize:11,color:C.muted}}>{days} · {times}</div>
                </div>
              ))}
            </Card>
          </div>
          <Card style={{padding:22}}>
            <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:14}}>📱 Post Preview</div>
            <div style={{background:"#000",borderRadius:16,overflow:"hidden",marginBottom:12}}>
              <div style={{height:200,background:`linear-gradient(135deg,${C.goldBg},rgba(201,168,76,0.02))`,display:"flex",alignItems:"center",justifyContent:"center",border:`1px solid ${C.borderGold}`}}>
                <div style={{textAlign:"center"}}>
                  <div style={{fontSize:48,marginBottom:8}}>✨</div>
                  <div style={{fontSize:12,color:C.muted}}>Your image here</div>
                </div>
              </div>
              <div style={{padding:"12px 14px"}}>
                <div style={{display:"flex",gap:8,marginBottom:8}}>
                  <div style={{width:28,height:28,borderRadius:"50%",background:C.goldBg,border:`1px solid ${C.borderGold}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:C.gold}}>E</div>
                  <div style={{fontSize:12,fontWeight:700,color:"#fff"}}>elyon_medspa</div>
                </div>
                <div style={{fontSize:12,color:"#fff",lineHeight:1.5}}>
                  Spring into a fresher you ✨ Our Botox is back with a spring special — 15% off this month only. Link in bio to book 💛
                  <span style={{color:"#4a9eff"}}> #MedSpa #BeverlyHills #Botox #Aesthetics #SpringGlow</span>
                </div>
              </div>
            </div>
            <div style={{display:"flex",gap:8}}>
              <Btn sz="sm" v="ghost">Instagram</Btn>
              <Btn sz="sm" v="ghost">TikTok</Btn>
              <Btn sz="sm" v="ghost">Facebook</Btn>
            </div>
          </Card>
        </div>
      )}

      {tab==="calendar"&&(
        <div>
          <div style={{display:"flex",gap:6,marginBottom:16}}>
            {["All","Reel","Post","Story","Email"].map(f=>(
              <button key={f} onClick={()=>setCalFilter(f)} style={{padding:"5px 12px",fontSize:11,fontWeight:calFilter===f?700:500,color:calFilter===f?"#09090b":C.muted,background:calFilter===f?C.gold:C.surface,border:`1px solid ${calFilter===f?C.gold:C.border}`,borderRadius:20,cursor:"pointer",fontFamily:F,transition:"all 0.15s"}}>{f}</button>
            ))}
            <Btn sz="sm" v="sec" style={{marginLeft:"auto"}}>+ Add Content</Btn>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {CONTENT_CAL.filter(c=>calFilter==="All"||c.type===calFilter).map((c,i)=>(
              <Card key={i} style={{padding:"14px 18px"}}>
                <div style={{display:"flex",alignItems:"center",gap:14}}>
                  <div style={{width:60,textAlign:"center",flexShrink:0}}>
                    <div style={{fontSize:16,fontWeight:800,color:C.gold,fontFamily:S}}>{c.date.split(" ")[1]}</div>
                    <div style={{fontSize:10,color:C.muted}}>{c.date.split(" ")[0]}</div>
                  </div>
                  <div style={{width:2,height:40,background:STATUS_COLORS[c.status]||C.muted,borderRadius:1,flexShrink:0}}/>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:600,color:C.text}}>{c.topic}</div>
                    <div style={{fontSize:11,color:C.muted}}>{c.type} · {c.platform}</div>
                  </div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    <span style={{fontSize:11,padding:"3px 10px",borderRadius:20,background:(STATUS_COLORS[c.status]||C.muted)+"20",color:STATUS_COLORS[c.status]||C.muted,fontWeight:600}}>{c.status}</span>
                    <Btn sz="sm" v="ghost">Edit</Btn>
                    {c.status==="idea"&&<Btn sz="sm" v="sec">Create →</Btn>}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ── LEAD MANAGEMENT ───────────────────────────────────────────────────────────
function LeadManagement(){
  const [leads,setLeads]=useState(LEADS);
  const [sel,setSel]=useState(null);
  const [showF,setShowF]=useState(false);
  const [form,setForm]=useState({});
  const STATUSES=["new","contacted","qualified","proposal","closed","lost"];
  const STATUS_COLORS={new:C.blue,contacted:C.teal,qualified:C.gold,proposal:C.purple,closed:C.green,lost:C.red};
  const totalValue=leads.filter(l=>l.status==="closed").reduce((s,l)=>s+l.value,0);
  const pipeline=leads.filter(l=>!["closed","lost"].includes(l.status)).reduce((s,l)=>s+l.value,0);

  return(
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14}}>
        <StatCard label="Total Leads" value={leads.length} color={C.gold} trend={18}/>
        <StatCard label="Pipeline Value" value={`$${pipeline.toLocaleString()}`} color={C.blue} sub="Active leads"/>
        <StatCard label="Closed This Month" value={`$${totalValue.toLocaleString()}`} color={C.green}/>
        <StatCard label="Conversion Rate" value={`${Math.round((leads.filter(l=>l.status==="closed").length/leads.length)*100)}%`} color={C.purple}/>
      </div>

      {/* Kanban */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:12,overflowX:"auto"}}>
        {STATUSES.map(status=>{
          const col=STATUS_COLORS[status];
          const statusLeads=leads.filter(l=>l.status===status);
          return(
            <div key={status}>
              <div style={{fontSize:11,fontWeight:700,color:col,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span>{status}</span>
                <span style={{background:col+"20",color:col,borderRadius:10,padding:"1px 6px",fontSize:10}}>{statusLeads.length}</span>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {statusLeads.map(lead=>(
                  <div key={lead.id} onClick={()=>setSel(lead===sel?null:lead)}
                    style={{padding:"12px",background:sel?.id===lead.id?C.goldBg:C.card,border:`1.5px solid ${sel?.id===lead.id?C.borderGold:C.border}`,borderRadius:10,cursor:"pointer",transition:"all 0.15s"}}>
                    <div style={{fontSize:12,fontWeight:700,color:C.text,marginBottom:3}}>{lead.name.split(" ")[0]}</div>
                    <div style={{fontSize:10,color:C.muted,marginBottom:6}}>{lead.interest}</div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div style={{fontSize:12,fontWeight:700,color:col}}>${lead.value}</div>
                      <div style={{fontSize:10,padding:"2px 6px",background:col+"20",color:col,borderRadius:6,fontWeight:700}}>{lead.score}</div>
                    </div>
                    <div style={{fontSize:10,color:C.dim,marginTop:4}}>{lead.source}</div>
                  </div>
                ))}
                {statusLeads.length===0&&<div style={{padding:"16px",textAlign:"center",color:C.dim,fontSize:10,background:C.surface,borderRadius:8,border:`1px dashed ${C.border}`}}>Empty</div>}
              </div>
            </div>
          );
        })}
      </div>

      {sel&&(
        <Card style={{padding:22}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
            <div>
              <div style={{fontSize:18,fontWeight:800,color:C.text,fontFamily:S,marginBottom:4}}>{sel.name}</div>
              <div style={{fontSize:12,color:C.muted}}>{sel.email} · {sel.phone}</div>
            </div>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <select value={sel.status} onChange={e=>{const newStatus=e.target.value;setLeads(ls=>ls.map(l=>l.id===sel.id?{...l,status:newStatus}:l));setSel({...sel,status:newStatus});}} style={{...inp,width:"auto",fontSize:12,padding:"6px 10px"}}>
                {STATUSES.map(s=><option key={s} value={s}>{s}</option>)}
              </select>
              <button onClick={()=>setSel(null)} style={{background:C.light,border:"none",borderRadius:8,padding:6,cursor:"pointer",color:C.muted}}>✕</button>
            </div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:14}}>
            {[["Source",sel.source,C.gold],["Interest",sel.interest,C.blue],["Value",`$${sel.value}`,C.green],["Lead Score",sel.score,sel.score>80?C.green:sel.score>60?C.gold:C.red]].map(([l,v,c])=>(
              <div key={l} style={{padding:"10px",background:C.surface,borderRadius:8,textAlign:"center",border:`1px solid ${C.border}`}}>
                <div style={{fontSize:11,color:C.muted,marginBottom:3}}>{l}</div>
                <div style={{fontSize:14,fontWeight:700,color:c}}>{v}</div>
              </div>
            ))}
          </div>
          <div style={{padding:"12px 14px",background:C.surface,borderRadius:8,border:`1px solid ${C.border}`,marginBottom:14,fontSize:12,color:C.muted}}>{sel.notes}</div>
          <div style={{display:"flex",gap:8}}>
            <Btn sz="sm" v="sec">📱 Send SMS</Btn>
            <Btn sz="sm" v="ghost">📧 Send Email</Btn>
            <Btn sz="sm" v="ghost">📅 Book Appointment</Btn>
            <Btn sz="sm" v="success">✓ Mark Closed</Btn>
          </div>
        </Card>
      )}
    </div>
  );
}

// ── REPUTATION MANAGEMENT ─────────────────────────────────────────────────────
function ReputationManagement(){
  const [reviews,setReviews]=useState(REVIEWS);
  const [replyText,setReplyText]=useState("");
  const [replyingTo,setReplyingTo]=useState(null);

  const avgRating=Math.round(reviews.reduce((s,r)=>s+r.rating,0)/reviews.length*10)/10;
  const fiveStars=reviews.filter(r=>r.rating===5).length;
  const unReplied=reviews.filter(r=>!r.replied).length;

  const PLATFORM_COLORS={Google:"#ea4335",Yelp:"#d32323",RealSelf:"#2563eb"};

  const generateReply=(review)=>{
    const positive=`Thank you so much for your wonderful review, ${review.author.split(" ")[0]}! We're absolutely thrilled to hear about your experience with us at Elyon. Our team works incredibly hard to deliver exceptional results, and knowing we've made a positive difference means everything to us. We look forward to welcoming you back! 💛\n\n— The Elyon Team`;
    const negative=`Thank you for taking the time to share your feedback, ${review.author.split(" ")[0]}. We sincerely apologize for the wait time — this is not the standard of service we strive to provide. We'd love the opportunity to make this right. Please reach out to us directly at info@elyonspa.com and we'll ensure your next visit exceeds expectations.\n\n— The Elyon Team`;
    setReplyText(review.rating>=4?positive:negative);
  };

  return(
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14}}>
        <StatCard label="Average Rating" value={`⭐ ${avgRating}`} color={C.gold} sub={`${reviews.length} total reviews`}/>
        <StatCard label="5-Star Reviews" value={fiveStars} color={C.green} sub={`${Math.round(fiveStars/reviews.length*100)}% of total`}/>
        <StatCard label="Need Reply" value={unReplied} color={unReplied>0?C.red:C.green} sub={unReplied>0?"Action required":"All caught up ✓"}/>
        <StatCard label="Platforms Monitored" value="200+" color={C.purple} sub="Google, Yelp, RealSelf +197"/>
      </div>

      <div style={{padding:"16px 20px",background:`linear-gradient(135deg,rgba(201,168,76,0.08),rgba(201,168,76,0.02))`,border:`1px solid ${C.borderGold}`,borderRadius:12}}>
        <div style={{fontSize:13,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:4}}>🌟 Review Request Automation</div>
        <div style={{fontSize:12,color:C.muted,marginBottom:12}}>Automatically send review requests after completed appointments</div>
        <div style={{display:"flex",gap:14,flexWrap:"wrap"}}>
          {[["Auto-send after checkout","Active",C.green],["Send via SMS + Email","Active",C.green],["24h delay","Active",C.green],["Smart timing (avoid evenings)","Active",C.teal]].map(([l,v,c])=>(
            <div key={l} style={{display:"flex",gap:6,alignItems:"center",fontSize:12}}>
              <div style={{width:8,height:8,borderRadius:"50%",background:c}}/>
              <span style={{color:C.muted}}>{l}:</span>
              <span style={{color:c,fontWeight:600}}>{v}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        {reviews.map(r=>(
          <Card key={r.id} style={{padding:20}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
              <div style={{display:"flex",gap:10,alignItems:"center"}}>
                <div style={{width:36,height:36,borderRadius:8,background:PLATFORM_COLORS[r.platform]+"20",border:`1px solid ${PLATFORM_COLORS[r.platform]}40`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:PLATFORM_COLORS[r.platform],flexShrink:0}}>{r.platform[0]}</div>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:C.text}}>{r.author}</div>
                  <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    <span style={{fontSize:14}}>{"⭐".repeat(r.rating)}{"☆".repeat(5-r.rating)}</span>
                    <span style={{fontSize:11,color:PLATFORM_COLORS[r.platform],fontWeight:600}}>{r.platform}</span>
                    <span style={{fontSize:11,color:C.dim}}>{r.date}</span>
                  </div>
                </div>
              </div>
              <div style={{display:"flex",gap:8}}>
                {r.replied?<span style={{fontSize:11,color:C.green,background:C.greenL,padding:"3px 10px",borderRadius:8,fontWeight:600}}>✓ Replied</span>:<span style={{fontSize:11,color:C.red,background:C.redL,padding:"3px 10px",borderRadius:8,fontWeight:600}}>Needs Reply</span>}
                {!r.replied&&<Btn sz="sm" v="sec" onClick={()=>{setReplyingTo(r);generateReply(r);}}>Reply</Btn>}
              </div>
            </div>
            <div style={{fontSize:13,color:C.text,lineHeight:1.6,fontStyle:"italic",marginBottom:replyingTo?.id===r.id?12:0}}>"{r.text}"</div>

            {replyingTo?.id===r.id&&(
              <div style={{marginTop:12,paddingTop:12,borderTop:`1px solid ${C.border}`}}>
                <div style={{fontSize:11,fontWeight:700,color:C.gold,marginBottom:8}}>YOUR REPLY (AI Generated — Edit as needed)</div>
                <textarea value={replyText} onChange={e=>setReplyText(e.target.value)} rows={4} style={{...inp,resize:"none",marginBottom:10}}/>
                <div style={{display:"flex",gap:8}}>
                  <Btn sz="sm" v="ghost" onClick={()=>setReplyingTo(null)}>Cancel</Btn>
                  <Btn sz="sm" v="ghost" onClick={()=>generateReply(r)}>↺ Regenerate</Btn>
                  <Btn sz="sm" onClick={()=>{setReviews(rs=>rs.map(x=>x.id===r.id?{...x,replied:true}:x));setReplyingTo(null);}}>Post Reply ✓</Btn>
                </div>
              </div>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
}

// ── TABS ──────────────────────────────────────────────────────────────────────
const LOGO_SVG=()=>(
  <svg width={32} height={32} viewBox="0 0 40 40" fill="none">
    <defs><linearGradient id="eg" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#e8c96a"/><stop offset="100%" stopColor="#8a6f2e"/></linearGradient></defs>
    <circle cx="20" cy="20" r="19" fill="none" stroke="#c9a84c" strokeWidth="1"/>
    <path d="M20 4L22.5 14.5L33 18L22.5 21.5L20 32L17.5 21.5L7 18L17.5 14.5Z" fill="url(#eg)"/>
    <circle cx="20" cy="20" r="3" fill="#09090b" stroke="#c9a84c" strokeWidth="1"/>
    <circle cx="20" cy="20" r="1.5" fill="url(#eg)"/>
  </svg>
);

const TABS=[
  {id:"trends",label:"Trend Studio",emoji:"🔥"},
  {id:"email",label:"Email Campaigns",emoji:"✉️"},
  {id:"sms",label:"SMS Campaigns",emoji:"📱"},
  {id:"meta",label:"Ad Brain",emoji:"📘"},
  {id:"social",label:"Social Studio",emoji:"📲"},
  {id:"leads",label:"Lead Pipeline",emoji:"🎯"},
  {id:"reputation",label:"Reputation",emoji:"⭐"},
];

export default function App(){
  const [tab,setTab]=useState("trends");

  return(
    <div style={{minHeight:"100vh",background:C.bg,fontFamily:F,color:C.text}}>
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&family=Cormorant+Garamond:wght@400;600;700;800&display=swap" rel="stylesheet"/>

      <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:"0 32px",height:58,display:"flex",alignItems:"center",gap:16,position:"sticky",top:0,zIndex:50,overflowX:"auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:10,marginRight:12,flexShrink:0}}>
          <LOGO_SVG/>
          <div style={{fontSize:16,fontWeight:800,color:"#c9a84c",fontFamily:S,letterSpacing:"0.1em"}}>ELYON</div>
          <div style={{fontSize:10,color:C.dim,background:C.goldBg,padding:"2px 8px",borderRadius:10,border:`1px solid rgba(201,168,76,0.2)`,letterSpacing:"0.08em",flexShrink:0}}>MARKETING</div>
        </div>
        <div style={{display:"flex",gap:4}}>
          {TABS.map(t=>(
            <button key={t.id} onClick={()=>setTab(t.id)} style={{padding:"6px 12px",fontSize:11,fontWeight:tab===t.id?700:500,color:tab===t.id?"#09090b":C.muted,background:tab===t.id?"#c9a84c":"transparent",border:`1px solid ${tab===t.id?"#c9a84c":C.border}`,borderRadius:8,cursor:"pointer",fontFamily:F,transition:"all 0.15s",display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}>
              <span>{t.emoji}</span><span>{t.label}</span>
            </button>
          ))}
        </div>
        <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:6,padding:"4px 10px",background:"rgba(46,204,135,0.1)",borderRadius:8,border:"1px solid rgba(46,204,135,0.2)",flexShrink:0}}>
          <div style={{width:6,height:6,borderRadius:"50%",background:"#2ecc87",boxShadow:"0 0 8px #2ecc87"}}/>
          <div style={{fontSize:10,color:"#c9a84c",fontWeight:700,letterSpacing:"0.06em"}}>HIPAA</div>
        </div>
      </div>

      <div style={{padding:"28px 32px"}}>
        <div style={{marginBottom:24}}>
          <div style={{fontSize:26,fontWeight:800,color:C.text,fontFamily:S}}>{TABS.find(t=>t.id===tab)?.emoji} {TABS.find(t=>t.id===tab)?.label}</div>
          <div style={{fontSize:12,color:C.muted,marginTop:4}}>Elyon Marketing Suite · Beverly Hills</div>
        </div>

        {tab==="trends"&&<TrendStudio/>}
        {tab==="email"&&<EmailCampaignsPro/>}
        {tab==="sms"&&<SMSCampaigns/>}
        {tab==="meta"&&<AdBrain/>}
        {tab==="social"&&<SocialStudio/>}
        {tab==="leads"&&<LeadManagement/>}
        {tab==="reputation"&&<ReputationManagement/>}
      </div>
    </div>
  );
}
